var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.svg)?_c('span',{staticClass:"tu-lang-flag",attrs:{"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.svg)}}):_c('tu-ui-icon',{attrs:{"name":"chats","size":16}})}
var staticRenderFns = []

export { render, staticRenderFns }